import * as Yup from 'yup'

const registerValidationSchema = Yup.object().shape({
    firstName: Yup.string()
        .required('El nombre es requerido'),
    lastName: Yup.string()
        .required('El apellido es requerido'),
    email: Yup.string()
        .email('Ingresa un email válido')
        .required('El email es requerido'),
    phone: Yup.string()
        .required('El teléfono es requerido'),
    dni: Yup.string()
        .matches(/^[0-9]{8}$/,'El DNI debe ser un número de 8 caracteres'),
    companyName: Yup.string()
        .required('La Empresa es requerida'),
    role: Yup.string()
        .required('La actividad es requerido'),
    base: Yup.string()
        .required('La base es requerido'),
})

export default registerValidationSchema
